var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4035 8.22262L19.9099 8.65496C21.4779 8.80539 21.9587 10.3371 20.748 11.3433L17.22 14.2754L18.5297 19.0521C18.9598 20.6207 17.6254 21.5703 16.2889 20.6263L12.0022 17.5983L7.71548 20.6263C6.38434 21.5665 5.04448 20.6209 5.47464 19.0521L6.78434 14.2754L3.25639 11.3433C2.04052 10.3328 2.51951 8.80607 4.09423 8.65496L8.59973 8.22262L10.5847 3.64603C11.2064 2.21282 12.7984 2.21354 13.4195 3.64618L15.4035 8.22262Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFilled);
export default __webpack_public_path__ + "static/media/favorite_filled.847d55d8c622aee8458684d1e8b013a4.svg";
export { ForwardRef as ReactComponent };